import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'signup-signup_skip_cta_click-action_category_click';

/**
 * event to track skip CTA on OwF Form
 */
export function trackSignupSignupSkipCtaClickActionCategoryClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
